if (!customElements.get('main-collection-banner-new')) {
    document.addEventListener('DOMContentLoaded', () => {
        class MainCollectionBannerNew extends HTMLElement {
            constructor() {
                super();

                this.selectors = {
                    halfImageWrapper: ".js-collection-banner-half-image-wrapper",
                    halfImage: ".js-collection-banner-half-image",
                    bannerAnchorLink: ".js-collection-banner-anchor"
                };

                this.attrs = {
                    isHalfImageParallax: "data-half-image-parallax"
                };

                this.classes = {
                    animated: "animated",
                    needAnimate: "need-animate",
                    fadeOut: "fade-out"
                };

                this.sectionIndex = +this.dataset.sectionIndex || 0;
                this.halfImages = [...this.querySelectorAll(this.selectors.halfImage)];
                this.mediaQuery = window.matchMedia('(min-width: 768px)');
                this.isDesktop = this.mediaQuery.matches;
                this.parallaxHandler = this.initParallax.bind(this);

                this.initAnchorLink();
                this.initAnimateObserver();
                this.sectionIndex === 1 && this.mediaQuery.addEventListener('change', this.handleMediaChange.bind(this));
            }

            handleMediaChange(event) {
                this.isDesktop = event.matches;

                this.isDesktop
                    ? this.beforeParallax(0)
                    : this.disableParallax();
            }

            initAnchorLink() {
                const anchorLink = this.querySelector(this.selectors.bannerAnchorLink);

                if (!anchorLink) return null;

                const href = anchorLink.getAttribute("href");

                if (!href || !href.startsWith("#")) return null;

                const target = document.querySelector(href);

                if (!target) return null;

                anchorLink.addEventListener("click", (event) => {
                    event.preventDefault();

                    let scrollTo = 0;

                    const header = document.querySelector('.header-section');

                    const headerHeight = parseInt(
                        getComputedStyle(document.documentElement).getPropertyValue("--header-height"),
                        10
                    ) || 0;
                    const stickyHeaderHeight = parseInt(
                        getComputedStyle(document.documentElement).getPropertyValue("--sticky-header-height"),
                        10
                    ) || 0;
                    const targetTop = target.getBoundingClientRect().top + window.scrollY;

                    if (header && header.classList.contains("header-sticky")) {
                        scrollTo = targetTop - stickyHeaderHeight;
                    } else {
                        scrollTo = targetTop - headerHeight;
                    }

                    window.scrollTo({
                        top: scrollTo,
                        behavior: "smooth",
                    });
                });
            }

            initAnimateObserver() {
                const observer = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (!entry.isIntersecting) return;

                        entry.target.classList.add(this.classes.animated);

                        entry.target.hasAttribute(this.attrs.isHalfImageParallax)
                        && this.halfImages.length
                        && this.isDesktop
                        && this.sectionIndex === 1
                        && this.beforeParallax(1750);

                        observer.unobserve(entry.target);
                    });
                }, {rootMargin: "-40px"});

                observer.observe(this);
            }

            beforeParallax(timer) {
                setTimeout(() => {
                    this.halfImages.forEach(hafImage => hafImage.classList.remove(this.classes.needAnimate));
                }, timer);

                this.enableParallax();
            }

            enableParallax() {
                ['touchmove', 'scroll'].forEach(event => {
                    document.addEventListener(event, this.parallaxHandler);
                });
            }

            disableParallax() {
                ['touchmove', 'scroll'].forEach(event => {
                    document.removeEventListener(event, this.parallaxHandler);
                });

                this.halfImages.forEach(image => {
                    image.style.transform = '';
                    image.classList.remove(this.classes.fadeOut);
                });
            }

            initParallax() {
                const notReadyForParallax = this.halfImages.some(item => item.classList.contains(this.classes.needAnimate));

                if (notReadyForParallax) return;

                const scrollY = window.scrollY;
                const halfImageWrapper = this.querySelector(this.selectors.halfImageWrapper);
                const halfImageWrapperBottom = halfImageWrapper.getBoundingClientRect().bottom || 0;
                const halfImageThreshold = 200;

                if (scrollY < 0) return;

                this.halfImages.forEach(item => {
                    item.classList.toggle(this.classes.fadeOut, halfImageWrapperBottom < halfImageThreshold);
                });

                this.updateParallaxState(scrollY);
            }

            updateParallaxState(scrollY) {
                const coefficients = [0.05, 0.2, 0.13];

                this.halfImages.forEach((item, index) => {
                    const targetCoefficient = coefficients[index] || 0;

                    item.style.transform = `translateY(${-scrollY * targetCoefficient}px)`;
                });
            }
        }

        customElements.define('main-collection-banner-new', MainCollectionBannerNew);
    });
}